
export const selectCrewList = (store) =>
  store.crewState.sort((a, b) => a < b );



// WEBPACK FOOTER //
// ./src/store/selectors/crew.js